import type { TaskTrackerRecurringTaskInterval } from './taskTrackerRecurringTasks.types'

export const TASK_TRACKER_RECURRING_TASK_TITLE_MAX_LENGTH = 200

/** Шаг минут в поле «Время» регулярной задачи. */
export const TASK_TRACKER_RECURRING_TASK_TIME_MINUTE_STEP_MINUTES = 10

export const TASK_TRACKER_RECURRING_TASK_TIME_HOUR_OPTIONS = Array.from(
  { length: 24 },
  (_, hour) => ({
    value: hour,
    label: String(hour).padStart(2, '0'),
  }),
)

export const TASK_TRACKER_RECURRING_TASK_TIME_MINUTE_OPTIONS = Array.from(
  {
    length: 60 / TASK_TRACKER_RECURRING_TASK_TIME_MINUTE_STEP_MINUTES,
  },
  (_, index) => {
    const value = index * TASK_TRACKER_RECURRING_TASK_TIME_MINUTE_STEP_MINUTES
    return {
      value,
      label: String(value).padStart(2, '0'),
    }
  },
)

export const TASK_TRACKER_RECURRING_TASK_INTERVAL_OPTIONS: {
  value: TaskTrackerRecurringTaskInterval
  label: string
}[] = [
  { value: 'daily', label: 'Ежедневно' },
  { value: 'weekly', label: 'Еженедельно' },
  { value: 'monthly', label: 'Ежемесячно' },
  { value: 'yearly', label: 'Ежегодно' },
]

export const TASK_TRACKER_RECURRING_TASK_WEEK_DAYS: {
  value: number
  label: string
  fullLabel: string
}[] = [
  { value: 1, label: 'Пн', fullLabel: 'Понедельник' },
  { value: 2, label: 'Вт', fullLabel: 'Вторник' },
  { value: 3, label: 'Ср', fullLabel: 'Среда' },
  { value: 4, label: 'Чт', fullLabel: 'Четверг' },
  { value: 5, label: 'Пт', fullLabel: 'Пятница' },
  { value: 6, label: 'Сб', fullLabel: 'Суббота' },
  { value: 7, label: 'Вс', fullLabel: 'Воскресенье' },
]

export const TASK_TRACKER_RECURRING_TASK_MONTH_OPTIONS: {
  value: number
  label: string
}[] = [
  { value: 1, label: 'Январь' },
  { value: 2, label: 'Февраль' },
  { value: 3, label: 'Март' },
  { value: 4, label: 'Апрель' },
  { value: 5, label: 'Май' },
  { value: 6, label: 'Июнь' },
  { value: 7, label: 'Июль' },
  { value: 8, label: 'Август' },
  { value: 9, label: 'Сентябрь' },
  { value: 10, label: 'Октябрь' },
  { value: 11, label: 'Ноябрь' },
  { value: 12, label: 'Декабрь' },
]

export const TASK_TRACKER_RECURRING_TASK_MONTH_DAY_OPTIONS = Array.from(
  { length: 31 },
  (_, index) => {
    const value = index + 1
    return { value, label: String(value) }
  },
)
